import React from 'react';
import type { Theme } from '../types';

interface OfflineBannerProps {
  pendingCount: number;
  darkMode: boolean;
  theme: Theme;
}

export function OfflineBanner({ pendingCount, darkMode, theme }: OfflineBannerProps) {
  return (
    <div
      className={`animate-rise-in mt-4 mb-5 rounded-[24px] border px-4 py-4 text-sm text-center ${
        darkMode
          ? 'border-amber-900/80 bg-[#2b2013] text-amber-100'
          : 'border-amber-300 bg-[#f7e5c8] text-amber-950'
      }`}
    >
      <span className='font-semibold tracking-[0.02em]'>Sin conexión</span>
      {pendingCount > 0 && (
        <span className={theme.textSecondary}>
          {' '}· {pendingCount} sin sincronizar
        </span>
      )}
    </div>
  );
}
